import React, { useState } from 'react';
import Select from 'react-select';
import { createUser } from "../../../api/manageUser";
import { getUsers } from "../../../slices/userSlice";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const AddUsers = () => {
  const dispatch = useDispatch();
  
  // Options de rôles disponibles
  const roleOptions = [
    { value: 'Serveur', label: 'Serveur' },
    { value: 'Cuisiner', label: 'Cuisiner' },
    { value: 'Manager', label: 'Manager' },
    { value: 'Barman', label: 'Barman' },
    { value: 'Caissier', label: 'Caissier' },
    { value: 'Econome', label: 'Econome' },
  ];

  // États pour les champs du formulaire
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState(null);
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  // États pour la visibilité des mots de passe
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // États pour le chargement et les erreurs
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Fonctions pour basculer la visibilité du mot de passe
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  // Gestion du submit du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation simple
    if (!username || !email || !role || !password || !passwordConfirmation) {
      setError('Veuillez remplir tous les champs.');
      return;
    }
    if (password !== passwordConfirmation) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }
    if (password.length < 8) {
        setError('Le mot de passe doit contenir au moins 8 caractères.');
        setLoading(false);
        return;
    
    }

    setLoading(true);

    // Constitution du payload à envoyer
    const userData = {
      username,
      email,
      role: role.value,
      password,
      password_confirmation:passwordConfirmation
    };

    try {
      const response = await createUser(userData);
      // Supposons que l'API renvoie la liste des utilisateurs mise à jour
      const users = response.data.users;
      dispatch(getUsers(users));
      setError();
      Swal.fire("Ajout !", userData.username + "a été ajouteé en tant que "+ userData.role + ' avec succès', "success");

      // Réinitialisation du formulaire
      setUsername('');
      setEmail('');
      setRole(null);
      setPassword('');
      setPasswordConfirmation('');
      setError('');
    } catch (err) {
      setError(err.response.data.message || "Erreur lors de l'ajout de l'utilisateur.");
    }
    setLoading(false);
  };

  return (
    <div>
      {/* Modal d'ajout d'utilisateur */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Nouvel Ajout</h4>
                  </div>
                  <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Nom d'utilisateur */}
                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>Nom d&apos;utilisateur</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Entrez un pseudo"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                      </div>
                      {/* Email */}
                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Ex: geaorge@gmail.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      {/* Sélection du rôle */}
                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>Role</label>
                          <Select
                            classNamePrefix="react-select"
                            options={roleOptions}
                            placeholder="Choisissez un rôle"
                            value={role}
                            onChange={setRole}
                          />
                        </div>
                      </div>
                      {/* Mot de passe */}
                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>Mot de passe</label>
                          <div className="pass-group">
                            <input
                              type={showPassword ? 'text' : 'password'}
                              className="pass-input"
                              placeholder="Entrer un mot de passe"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                              className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                              onClick={handleTogglePassword}
                            />
                          </div>
                        </div>
                      </div>
                      {/* Confirmation du mot de passe */}
                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>Confirmation du mot de passe</label>
                          <div className="pass-group">
                            <input
                              type={showConfirmPassword ? 'text' : 'password'}
                              className="pass-input"
                              placeholder="Confirmez le mot de passe"
                              value={passwordConfirmation}
                              onChange={(e) => setPasswordConfirmation(e.target.value)}
                            />
                            <span
                              className={`fas toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                              onClick={handleToggleConfirmPassword}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Affichage de l'erreur */}
                    {error && <p className="text-danger">{error}</p>}
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Retour
                      </button>
                      <button type="submit" className="btn btn-submit" disabled={loading}>
                        {loading ? "Ajout en cours..." : "Ajouter"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
      {/* /Modal d'ajout d'utilisateur */}
    </div>
  );
};

export default AddUsers;
